<template>
  <div class="three-col-shell w-full mx-auto box-border overflow-x-hidden">
    <div class="three-col flex w-full items-start justify-center box-border">
      <div class="three-col__side three-col__side--left hidden md:flex" aria-hidden="true">
        <img
          class="three-col__bandeau three-col__bandeau--lg"
          :src="bandeauGaucheSrc"
          alt=""
          width="120"
          height="1200"
        />
        <img
          class="three-col__bandeau three-col__bandeau--md"
          :src="bandeauGaucheMdSrc"
          alt=""
          width="98"
          height="1176"
        />
        <img
          class="three-col__bandeau three-col__bandeau--xl"
          :src="bandeauGaucheXlSrc"
          alt=""
          width="120"
          height="2400"
        />
      </div>

      <div class="three-col__center">
        <slot />
      </div>

      <div class="three-col__side three-col__side--right hidden md:flex" aria-hidden="true">
        <img
          class="three-col__bandeau three-col__bandeau--lg"
          :src="bandeauDroiteSrc"
          alt=""
          width="120"
          height="1200"
        />
        <img
          class="three-col__bandeau three-col__bandeau--md"
          :src="bandeauDroiteMdSrc"
          alt=""
          width="98"
          height="1176"
        />
        <img
          class="three-col__bandeau three-col__bandeau--xl"
          :src="bandeauDroiteXlSrc"
          alt=""
          width="120"
          height="2400"
        />
      </div>
    </div>
  </div>
</template>

<script>
import bandeauGauche from "@/assets/images/home/bandeau-gauche.svg";
import bandeauDroite from "@/assets/images/home/bandeau-droite.svg";
import bandeauGaucheMd from "@/assets/images/home/bandeau-gauche-md.svg";
import bandeauDroiteMd from "@/assets/images/home/bandeau-droite-md.svg";
import bandeauGaucheXl from "@/assets/images/bandeau-gauche-xl.svg";
import bandeauDroiteXl from "@/assets/images/bandeau-droite-xl.svg";

export default {
  name: "ThreeColumnLayout",
  data() {
    return {
      bandeauGaucheSrc: bandeauGauche,
      bandeauDroiteSrc: bandeauDroite,
      bandeauGaucheMdSrc: bandeauGaucheMd,
      bandeauDroiteMdSrc: bandeauDroiteMd,
      bandeauGaucheXlSrc: bandeauGaucheXl,
      bandeauDroiteXlSrc: bandeauDroiteXl,
    };
  },
};
</script>

<style lang="scss" scoped>
/* Largeur max : 2 bandeaux (120px) + colonne centrale = 1250px tout compris */
.three-col-shell {
  width: 100%;
  max-width: 1024px;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;

  /* Mobile créa : blocs centrés sans bandeaux latéraux */
  @media (max-width: 767px) {
    max-width: 100%;
  }
}

.three-col {
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: center;
  box-sizing: border-box;
}

/*
 * Bandeaux latéraux : fluides entre 98px (768px viewport) et 120px (1250px+)
 * clamp(98, 9.3vw, 120) → 98px@768 · 120px@1290
 */
.three-col__side {
  flex: 0 0 clamp(98px, 9.3vw, 120px);
  width: clamp(98px, 9.3vw, 120px);
  min-width: 0;
  max-width: 120px;
  display: flex;
  justify-content: center;
  align-self: stretch;
  position: relative;

  @media (max-width: 767px) {
    display: none;
  }
}

.three-col__bandeau {
  display: block;
  width: 100%;
  max-width: 120px;
  max-height: 1200px;
  height: auto;
  object-fit: contain;
  object-position: top center;
}

/* Desktop : bandeaux -md et -xl masqués par défaut */
.three-col__bandeau--md,
.three-col__bandeau--xl {
  display: none;
}

/*
 * Colonne centrale : fluide, prend tout l'espace entre les deux bandeaux
 * max-width 1010px desktop, 828px tablet – pas de largeur fixe → pas d'overflow
 */
.three-col__center {
  flex: 1 1 auto;
  min-width: 0;
  max-width: 1010px;
  box-sizing: border-box;

  @media (max-width: 767px) {
    max-width: 100%;
  }
}

/*
 * Tablette 768–1024 : shell max 1024px · bandeaux fluides · centre max 828px
 */
@media (min-width: 768px) and (max-width: 1024px) {
  .three-col-shell {
    max-width: 1024px;
  }

  .three-col__bandeau {
    max-width: 98px;
    max-height: 1176px;
  }

  .three-col__bandeau--lg {
    display: none;
  }

  .three-col__bandeau--md {
    display: block;
  }

  .three-col__center {
    /* Fluide : viewport − 2 × bandeau (clamp 98-120px), max 828px */
    max-width: 828px;
  }
}

/*
 * Grand écran >1024px : shell pleine largeur, bandeaux collés aux bords.
 * Le centre s'étire pour remplir exactement l'espace entre les deux bandeaux (120px × 2) :
 * calc(100% - 240px) aligne le centre sur les bords intérieurs des colonnes.
 * Plafonné à 1680px (atteint à 1920px de viewport).
 */
@media (min-width: 1025px) {
  .three-col-shell {
    max-width: none;
  }

  .three-col {
    position: relative;
  }

  .three-col__side--left {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    flex: none;
    width: 120px;
    z-index: 2;
  }

  .three-col__side--right {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    flex: none;
    width: 120px;
    z-index: 2;
  }

  .three-col__center {
    max-width: min(calc(100% - 240px), 1680px);
  }
}

/*
 * ≥1250px : bandeaux XL affichés, bandeaux LG masqués.
 * overflow: hidden sur les colonnes : l'image (2400px) se découpe au bas.
 */
@media (min-width: 1250px) {

  .three-col__bandeau--lg {
    display: none;
  }

  .three-col__bandeau--xl {
    display: block;
    width: 100%;
    height: 100%;
    max-height: none;
    object-fit: cover;
    object-position: top center;
  }

  .three-col__side {
    overflow: hidden;
  }
}
</style>
